var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import noop from 'lodash/noop';
import React, { useCallback, useMemo, } from 'react';
import { FormattedMessage, useIntl, } from 'react-intl';
import { useHistory, useLocation, } from 'react-router-dom';
import { MenuSection } from '@folio/stripes/components';
import { IfPermission, TitleManager, useNamespace, } from '@folio/stripes/core';
import { ColumnManagerMenu, PersistedPaneset, useColumnManager, } from '@folio/stripes/smart-components';
import { DelayClaimActionMenuItem, DelayClaimsModal, FiltersPane, getClaimingIntervalFromDate, getFiltersCount, MarkUnreceivableActionMenuItem, NoResultsMessage, PIECE_STATUS, ResetButton, RESULT_COUNT_INCREMENT, ResultsPane, SEARCH_PARAMETER, SendClaimActionMenuItem, SendClaimsModal, SingleSearchForm, useClaimsDelay, useClaimsSend, useFiltersReset, useFiltersToogle, useLocationFilters, useLocationSorting, useModalToggle, usePagination, usePiecesStatusBatchUpdate, useRecordsSelect, useShowCallout, } from '@folio/stripes-acq-components';
import { ClaimingList, ClaimingListFilters, GroupByOrgActionMenuItem, MarkUnreceivableModal, } from './components';
import { CLAIMING_HIDDEN_LIST_COLUMNS, CLAIMING_LIST_COLUMNS, CLAIMING_LIST_SORTABLE_FIELDS, FILTERS, RESPONSE_ERROR_CODE, } from './constants';
import { useClaimErrorsHandler, useClaiming, } from './hooks';
import { CLAIMING_SEARCHABLE_INDICES } from './search';
import { getResultsListColumnMapping } from './utils';
var resetData = noop;
var SEARCH_INDICES = __spreadArray([
    {
        labelId: 'ui-claims.search.index.keyword',
        value: '',
    }
], CLAIMING_SEARCHABLE_INDICES.map(function (index) { return ({ labelId: "ui-claims.search.index.".concat(index), value: index }); }), true);
var FILTERS_OPTIONS = {};
var DEFAULT_FILTERS = (_a = {},
    _a[FILTERS.POL_CLAIMING_ACTIVE] = ['true'],
    _a[FILTERS.RECEIVING_STATUS] = [PIECE_STATUS.late],
    _a);
export var Claiming = function () {
    var intl = useIntl();
    var history = useHistory();
    var location = useLocation();
    var namespace = useNamespace({ key: 'filters' })[0];
    var showCallout = useShowCallout();
    var _a = useFiltersToogle(namespace), isFiltersOpened = _a.isFiltersOpened, toggleFilters = _a.toggleFilters;
    var _b = useModalToggle(), isClaimDelayModalOpen = _b[0], toggleClaimDelayModal = _b[1];
    var _c = useModalToggle(), isClaimSendModalOpen = _c[0], toggleClaimSendModal = _c[1];
    var _d = useModalToggle(), isMarkUnreceivableModalOpen = _d[0], toggleMarkUnreceivableModalOpen = _d[1];
    var _e = useLocationFilters(location, history, resetData, FILTERS_OPTIONS, DEFAULT_FILTERS), filters = _e[0], searchQuery = _e[1], applyFilters = _e[2], applySearch = _e[3], changeSearch = _e[4], resetFilters = _e[5], changeIndex = _e[6], searchIndex = _e[7];
    var _f = useLocationSorting(location, history, resetData, CLAIMING_LIST_SORTABLE_FIELDS), sortingField = _f[0], sortingDirection = _f[1], changeSorting = _f[2];
    var _g = usePagination({ limit: RESULT_COUNT_INCREMENT, offset: 0 }), pagination = _g.pagination, changePage = _g.changePage;
    var _h = useClaimsSend(), isSendClaimLoading = _h.isLoading, sendClaims = _h.sendClaims;
    var _j = useClaimsDelay(), delayClaims = _j.delayClaims, isDelayClaimsLoading = _j.isLoading;
    var _k = usePiecesStatusBatchUpdate(), isPiecesStatusUpdateLoading = _k.isLoading, updatePiecesStatus = _k.updatePiecesStatus;
    var _l = useClaiming({
        filters: filters,
        pagination: pagination,
        sorting: { sorting: sortingField, sortingDirection: sortingDirection },
    }), claims = _l.claims, isFetching = _l.isFetching, refetch = _l.refetch, totalRecords = _l.totalRecords;
    useFiltersReset(resetFilters);
    var _m = useRecordsSelect({ records: claims }), allRecordsSelected = _m.allRecordsSelected, resetAllSelectedRecords = _m.resetAllSelectedRecords, resetOtherSelectedRecordsByIds = _m.resetOtherSelectedRecordsByIds, selectedRecordsLength = _m.selectedRecordsLength, selectedRecordsMap = _m.selectedRecordsMap, selectRecord = _m.selectRecord, toggleSelectAll = _m.toggleSelectAll;
    var handlerErrorResponse = useClaimErrorsHandler().handlerErrorResponse;
    var columnMapping = useMemo(function () {
        return getResultsListColumnMapping({
            disabled: isFetching,
            intl: intl,
            isAllSelected: allRecordsSelected,
            selectAll: toggleSelectAll,
        });
    }, [allRecordsSelected, intl, isFetching, toggleSelectAll]);
    var _o = useColumnManager('claiming-list', columnMapping), toggleColumn = _o.toggleColumn, visibleColumns = _o.visibleColumns;
    var queryFilter = filters === null || filters === void 0 ? void 0 : filters[SEARCH_PARAMETER];
    var pageTitle = queryFilter ? intl.formatMessage({ id: 'ui-claims.document.title.search' }, { query: queryFilter }) : null;
    var sortByOrg = function (e) {
        if (sortingField !== CLAIMING_HIDDEN_LIST_COLUMNS.vendorId) {
            changeSorting(e, { name: CLAIMING_HIDDEN_LIST_COLUMNS.vendorId });
        }
    };
    var renderActionMenu = function (_a) {
        var onToggle = _a.onToggle;
        return (React.createElement(React.Fragment, null,
            React.createElement(MenuSection, null,
                React.createElement(IfPermission, { perm: "orders.wrapper-pieces.collection.get" },
                    React.createElement(GroupByOrgActionMenuItem, { onClick: function (e) {
                            onToggle(e);
                            sortByOrg(e);
                        } })),
                React.createElement(IfPermission, { perm: "pieces.send-claims.collection.post" },
                    React.createElement(SendClaimActionMenuItem, { disabled: !selectedRecordsLength, onClick: function (e) {
                            onToggle(e);
                            toggleClaimSendModal();
                        } })),
                React.createElement(IfPermission, { perm: "orders.pieces.collection.put" },
                    React.createElement(DelayClaimActionMenuItem, { disabled: !selectedRecordsLength, onClick: function (e) {
                            onToggle(e);
                            toggleClaimDelayModal();
                        } }),
                    React.createElement(MarkUnreceivableActionMenuItem, { disabled: !selectedRecordsLength, onClick: function (e) {
                            onToggle(e);
                            toggleMarkUnreceivableModalOpen();
                        } }))),
            React.createElement(ColumnManagerMenu, { prefix: "claiming", columnMapping: columnMapping, visibleColumns: visibleColumns, toggleColumn: toggleColumn, excludeColumns: [CLAIMING_LIST_COLUMNS.select] })));
    };
    var resultsStatusMessage = (React.createElement(NoResultsMessage, { isLoading: isFetching, filters: filters, isFiltersOpened: isFiltersOpened, toggleFilters: toggleFilters }));
    var onClaimsSend = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var errors_1;
        var _c;
        var claimingDate = _b.claimingDate, externalNote = _b.externalNote, internalNote = _b.internalNote;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, sendClaims({
                            data: {
                                claimingInterval: getClaimingIntervalFromDate(claimingDate),
                                claimingPieceIds: Object.keys(selectedRecordsMap),
                                externalNote: externalNote,
                                internalNote: internalNote,
                            },
                        })];
                case 1:
                    _d.sent();
                    resetAllSelectedRecords();
                    showCallout({ messageId: 'ui-claims.claiming.sendClaim.success.message' });
                    return [3 /*break*/, 4];
                case 2:
                    errors_1 = _d.sent();
                    return [4 /*yield*/, handlerErrorResponse(errors_1.response, {
                            callbacksDict: (_c = {},
                                _c[RESPONSE_ERROR_CODE.unableToGenerateClaimsForOrgNoIntegrationDetails] = function (_a) {
                                    var pieceIds = _a.pieceIds;
                                    resetOtherSelectedRecordsByIds(pieceIds);
                                },
                                _c[RESPONSE_ERROR_CODE.cannotFindPiecesWithLatestStatusToProcess] = function (_a) {
                                    var pieceIds = _a.pieceIds;
                                    resetOtherSelectedRecordsByIds(pieceIds);
                                },
                                _c),
                            defaultMessageId: 'ui-claims.claiming.sendClaim.error.message',
                        })];
                case 3:
                    _d.sent();
                    return [3 /*break*/, 4];
                case 4:
                    refetch();
                    toggleClaimSendModal();
                    return [2 /*return*/];
            }
        });
    }); }, [
        handlerErrorResponse,
        refetch,
        resetAllSelectedRecords,
        resetOtherSelectedRecordsByIds,
        selectedRecordsMap,
        sendClaims,
        showCallout,
        toggleClaimSendModal,
    ]);
    var onClaimsDelay = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var errors_2;
        var claimingDate = _b.claimingDate;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, delayClaims({
                            claimingInterval: getClaimingIntervalFromDate(claimingDate),
                            pieceIds: Object.keys(selectedRecordsMap),
                        })];
                case 1:
                    _c.sent();
                    resetAllSelectedRecords();
                    showCallout({ messageId: 'ui-claims.claiming.delayClaim.success.message' });
                    return [3 /*break*/, 4];
                case 2:
                    errors_2 = _c.sent();
                    return [4 /*yield*/, handlerErrorResponse(errors_2.response, { defaultMessageId: 'ui-claims.claiming.delayClaim.error.message' })];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 4:
                    refetch();
                    toggleClaimDelayModal();
                    return [2 /*return*/];
            }
        });
    }); }, [
        delayClaims,
        handlerErrorResponse,
        refetch,
        resetAllSelectedRecords,
        selectedRecordsMap,
        showCallout,
        toggleClaimDelayModal,
    ]);
    var onMarkUnreceivable = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var errors_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, updatePiecesStatus({
                            data: {
                                pieceIds: Object.keys(selectedRecordsMap),
                                receivingStatus: PIECE_STATUS.unreceivable,
                            },
                        })];
                case 1:
                    _a.sent();
                    resetAllSelectedRecords();
                    showCallout({ messageId: 'ui-claims.claiming.markUnreceivable.success.message' });
                    return [3 /*break*/, 4];
                case 2:
                    errors_3 = _a.sent();
                    return [4 /*yield*/, handlerErrorResponse(errors_3.response, { defaultMessageId: 'ui-claims.claiming.markUnreceivable.error.message' })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 4:
                    refetch();
                    toggleMarkUnreceivableModalOpen();
                    return [2 /*return*/];
            }
        });
    }); }, [
        handlerErrorResponse,
        refetch,
        resetAllSelectedRecords,
        selectedRecordsMap,
        showCallout,
        toggleMarkUnreceivableModalOpen,
        updatePiecesStatus,
    ]);
    return (React.createElement("div", null,
        React.createElement(TitleManager, { page: pageTitle }),
        React.createElement(PersistedPaneset, { appId: "ui-claims", id: "claiming-paneset" },
            isFiltersOpened && (React.createElement(FiltersPane, { id: "claiming-filters-pane", toggleFilters: toggleFilters },
                React.createElement(SingleSearchForm, { applySearch: applySearch, changeSearch: changeSearch, searchQuery: searchQuery, isLoading: isFetching, ariaLabelId: "ui-claims.titles.search", searchableIndexes: SEARCH_INDICES, changeSearchIndex: changeIndex, selectedIndex: searchIndex }),
                React.createElement(ResetButton, { id: "reset-receiving-filters", reset: resetFilters, disabled: !getFiltersCount(filters) || isFetching }),
                React.createElement(ClaimingListFilters, { activeFilters: filters, applyFilters: applyFilters, disabled: isFetching }))),
            React.createElement(ResultsPane, { id: "claiming-results-pane", autosize: true, title: intl.formatMessage({ id: 'ui-claims.claiming.results.title' }), renderActionMenu: renderActionMenu, count: totalRecords, toggleFiltersPane: toggleFilters, filters: filters, isFiltersOpened: isFiltersOpened, isLoading: isFetching }, (function (_a) {
                var height = _a.height, width = _a.width;
                return (React.createElement(ClaimingList, { columnMapping: columnMapping, contentData: claims, height: height, isEmptyMessage: resultsStatusMessage, isLoading: isFetching, onHeaderClick: changeSorting, onNeedMoreData: changePage, onSelect: selectRecord, pagination: pagination, selectedRecordsDict: selectedRecordsMap, sortDirection: sortingDirection, sortingField: sortingField, totalCount: totalRecords, visibleColumns: visibleColumns, width: width }));
            }))),
        React.createElement(DelayClaimsModal, { claimsCount: selectedRecordsLength, disabled: isDelayClaimsLoading, open: isClaimDelayModalOpen, onCancel: toggleClaimDelayModal, onSubmit: onClaimsDelay }),
        React.createElement(SendClaimsModal, { claimsCount: selectedRecordsLength, disabled: isSendClaimLoading, message: (React.createElement(FormattedMessage, { id: "ui-claims.claiming.sendClaim.modal.message", values: { count: selectedRecordsLength } })), open: isClaimSendModalOpen, onCancel: toggleClaimSendModal, onSubmit: onClaimsSend }),
        React.createElement(MarkUnreceivableModal, { claimsCount: selectedRecordsLength, disabled: isPiecesStatusUpdateLoading, open: isMarkUnreceivableModalOpen, onCancel: toggleMarkUnreceivableModalOpen, onSubmit: onMarkUnreceivable })));
};
